import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_TEMPLATES = gql`
  query SearchTemplates($input: SearchInput!) {
    searchPolicyTemplates(input: $input) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          name
          id
          type
          body
          description
          labels
        }
      }
    }
  }
`;

export const SEARCH_TEMPLATES_SUGGESTIONS = gql`
  query SearchTemplatesSuggestions($input: SearchSuggestionsInput!) {
    searchPolicyTemplatesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
